// factory rotate character method
const createRotateAnimation = (target) => { 
  return (tl, options) => { 
    options.flipped = options.flipped || false
    tl
      .add({
        targets: target,
        scaleX: {
          value: options.flipped ? -1 : 1,
          duration: 1
        }, // flip character conditionally
        begin: options.begin,
        complete: options.complete
      })
  }
}

export {createRotateAnimation}


// WEBPACK FOOTER //
// ./src/assets/js/utils/createRotateAnimation.js